import { Component, Input, Output, EventEmitter } from "@angular/core";

import { PaymentTypes } from "../_models/index";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  selector: "refund-logic",
  moduleId: module.id,
  templateUrl: "refund-logic.component.html",
})
export class RefundLogicComponent {
  @Input() item: any;
  @Input() messages: any;
  @Input() className?: string;
  @Input() isIcon?: boolean; //when isIcon, it means that it comes from cancel cash on open receipts
  @Output() actionCompleted: EventEmitter<void> = new EventEmitter<void>();
  loading = false;
  done = false;
  modalReference: any;
  modalPopupReference: any;
  errorMessage: string;
  modalMessage: string;
  popupText: string;
  modalOkButton: string;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private dataService: DataService,
    private alertService: AlertService
  ) {}

  open(content) {
    this.modalOkButton = this.messages["approve"];
    if (this.item.isMeshutaf && this.item.itemStatus == "NEW") {
      this.modalMessage = this.messages["refund_request_meshutaf_NEW"];
      this.modalOkButton = "לאישור בקשת ההחזר";
      let options: NgbModalOptions = {
        windowClass: "modal-opened",
        backdrop: "static",
      };
      this.modalReference = this.modalService.open(content, options);
    } else if (
      this.item.paymentType >= PaymentTypes.PAYMENT_TYPE_CASH &&
      this.item.paymentType <= PaymentTypes.PAYMENT_TYPE_CASH_PARTLY_REFUNDED
    ) {
      this.modalMessage = this.messages["confirm_refund"];
      this.modalOkButton = this.messages["refund_request_cash"];
      let options: NgbModalOptions = {
        windowClass: "modal-opened",
        backdrop: "static",
      };
      this.modalReference = this.modalService.open(content, options);
    } else {
      this.loading = true;
      this.dataService.refund(this.item, true, false).subscribe(
        (data) => {
          this.modalMessage = JSON.stringify(data);
          this.loading = false;
          if (data && data.allowedPercent) {
            this.modalMessage = this.item.isMeshutaf
              ? "בהתאם לנוהל ההחזרים, יתבצע לישוב זיכוי של " +
                data.allowedPercent +
                "%"
              : "בהתאם לנוהל ההחזרים  זכאי ל" +
                data.allowedPercent +
                "%" +
                " החזר";
            this.modalOkButton = "לאישור בקשת ההחזר";
            let options: NgbModalOptions = {
              windowClass: "modal-opened",
              backdrop: "static",
            };
            this.modalReference = this.modalService.open(content, options);
          } else {
            localStorage.setItem("refundItem", JSON.stringify(this.item));
            this.router.navigate(["/refund"]);
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage =
            error && error.statusText
              ? decodeURIComponent(error.statusText)
              : error;
          this.done = true;
        }
      );
    }
  }

  redirectToRefundRequest() {
    this.modalReference.close();
    localStorage.setItem("refundItem", JSON.stringify(this.item));
    this.router.navigate(["/refund"]);
  }

  public refund() {
    if (!this.loading == true) {
      this.loading = true;
      this.dataService.refund(this.item, false, this.isIcon).subscribe(
        (data) => {
          if (data && data.allowedAmount) {
          } else if (data && data.allowRequest) {
            this.modalReference.close();
            localStorage.setItem("refundItem", JSON.stringify(this.item));
            this.router.navigate(["/refund"]);
          } else {
            this.done = true;
            this.modalReference.close();
            // here method of parent
            this.actionCompleted.emit();
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage =
            error && error.statusText
              ? decodeURIComponent(error.statusText)
              : error;
          this.done = true;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/refund/refund-logic.component.ts